module.exports = "/_next/static/images/Functions@2x-11f7bb0ca667d5d930398dc96f574131.webp";